<div class="layout-wrapper" [ngClass]="containerClass">
    <p-panel #container>
        <p-blockUI [blocked]="blockUI.blocked">
            <i class="pi pi-spinner pi-spin" style="font-size: 3rem"></i>
        </p-blockUI>
        <app-topbar></app-topbar>
        <ng-container *ngIf="showPortalShell; else holdOutlet">
            <div class="layout-sidebar">
                <app-sidebar></app-sidebar>
            </div>
            <div class="layout-main-container">
                <div class="layout-main">
                    <router-outlet></router-outlet>
                </div>
                <app-footer></app-footer>
            </div>
            <app-config></app-config>
            <div class="layout-mask"></div>
        </ng-container>
        <ng-template #holdOutlet>
            <div class="layout-tenant-blocked-outlet" aria-hidden="true" style="position:absolute;width:0;height:0;overflow:hidden;pointer-events:none">
                <router-outlet></router-outlet>
            </div>
        </ng-template>
    </p-panel>
</div>
